import * as React from 'react';
import { Control } from 'react-redux-form';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {IHistory, IOwnProps} from '../../interfaces';
import {ModuleModel} from '../../model/ModuleModel';
import {getModuleDetails, updateModule} from '../../services/moduleService';
import {isArrayEmpty, isFormEmpty} from '../../utils/generalUtils';
import {Async} from '../reusableComponents/Async';
import {BasePage} from '../reusableComponents/BasePage';
import {ErrorPage} from '../reusableComponents/ErrorPage';
import {Form} from '../reusableComponents/FormComponents/Form';
import {FormFooter} from '../reusableComponents/FormComponents/FormFooter';
import {InputField} from '../reusableComponents/FormComponents/InputField';
import {Loader} from '../reusableComponents/Loader/Loader';
import {FileInputComponent} from './FileInputComponent';
import './modules.scss';
import {QuestionsTable} from './QuestionsTable';
import {InstructionsTable} from './InstructionsTable';
import { FILESALLOWEDEXTENSION, FILESALLOWEDEXE } from 'src/constants/generals';
import {getCategoryDetails} from '../../services/moduleService';
import { getUserData } from 'src/services/utilityServices';
import * as console from 'console';

export interface IUpdateModuleProps extends IOwnProps {
    history: IHistory;
    moduleInstance: ModuleModel;
    id: string;
    moduleType?: string;
}

export class UpdateModuleImpl extends React.Component<IUpdateModuleProps, { selectedLevel: string[], categoryList: [], subCategoryList: string[], subCategoryOpt : string[]}> {
    constructor(props: IUpdateModuleProps) {
        super(props);
        this.state = {selectedLevel: [], categoryList: [], subCategoryList: [],subCategoryOpt : []};
    }

    public refs: {
        links: FileInputComponent;
        questions: QuestionsTable;
        instructionsTable: InstructionsTable;
    };

    public promise = async () => {
        await getModuleDetails(this.props.id);
        const CategoryArr = await getCategoryDetails();
        this.setState({categoryList: CategoryArr[0]});
        this.setState({subCategoryList: CategoryArr[1]});
        this.subcategoryOptions(this.props.moduleInstance.props.Category);
    }

    public categoryOptions = () => {
        let UserData = getUserData().category;
        // UserData = '1';
        let idStr = '';
        let categoryOptions = [];
        for ( let i = 0; i < this.state.categoryList.length; i++ ) {
            let arr = this.state.categoryList[i];
            if(UserData == arr[0] || UserData === 'all') {
                idStr = arr[0];
                idStr = idStr.toString();
                categoryOptions.push({label: arr[1], value: idStr});
            }
       }
    //    if (this.state.subCategoryOpt.length == 0) {
    //         this.subcategoryOptions(this.props.moduleInstance.props.Category);
    //    }
    //    let idArr = [];
    //    idArr.push(this.props.moduleInstance.props.Category);
    //     this.setState({
    //         selectedLevel: idArr
    //     });
        // this.subcategoryOptions(this.props.moduleInstance.props.Category);
        return categoryOptions;
    }

    public subcategoryOptions = (SubCategory) => {
        let subcategoryOptions = [];
        let subCategoryOptList = [];
        // const selCategoryOptions = this.state.selectedLevel;
        // alert(selCategoryOptions);
        subCategoryOptList = this.state.subCategoryList;
        let idStr = ''; 
        let key = Number[0];
        // let CategoryID = selCategoryOptions;
        let CategoryID = SubCategory;
        for ( let j = 0; j < subCategoryOptList.length; j++ ) {
            let arr = subCategoryOptList[j];
            let ObjKeys = Object.keys(subCategoryOptList[j]);
            if ( ObjKeys == CategoryID ) {
                key = CategoryID;
                let newArr = arr[key];
                for ( let k = 0; k < newArr.length; k++ ) {
                    let subCatOpt = newArr[k];
                    idStr = subCatOpt[0];
                    idStr = idStr.toString();    
                    subcategoryOptions.push({label: subCatOpt[1], value: idStr});
                }
            }
        }
        this.setState({
            subCategoryOpt: subcategoryOptions
        });
        return subcategoryOptions;                   
    }
    // public getDefaultModules = (SelectedArr) => {
    //     let categoryOptions = [];
    //     let idStr ='';
    //     // for ( let i = 0; i <SelectedArr.length; i++ ) {
    //         for ( let j = 0; j < this.state.categoryList.length; j++ ) {
    //             let arr = this.state.categoryList[j];
    //             if(SelectedArr == arr[0]){
    //                 idStr = arr[0];
    //                 categoryOptions.push({label: arr[1], value: idStr});
    //             }
    //         }
    //     return categoryOptions;
   
    // }
    // public getDefaultSubValues = (SelectedArr) => {
    //     let categoryOptions = [];
    //     let idStr ='';
    //     // for ( let i = 0; i <SelectedArr.length; i++ ) {
    //         for ( let j = 0; j < this.state.categoryList.length; j++ ) {
    //             let arr = this.state.categoryList[j];
    //             if(SelectedArr == arr[0]){
    //                 idStr = arr[0];
    //                 categoryOptions.push({label: arr[1], value: idStr});
    //             }
    //         }
    //     // this.setState({
    //     //     subCategoryOpt: categoryOptions
    //     // });
    
    //     return '1';
   
    // }
    public onCategoryChange = async (value) => {
        if (value) {
            await this.setState({
                selectedLevel: value
            });
            const category = this.state.selectedLevel;
            let newarr = this.subcategoryOptions(category);
        }
    }

    public handleSubmit = async (values) => {
        const {ModuleType} = this.props.moduleInstance.props;
        const currentModuleType = this.props.moduleType !== 'Training Module' ? this.props.moduleType : (ModuleType || 'Training Module');
        const isInstruction = currentModuleType === 'Instruction Module';
        
        let ignoreList = ['Instructions', 'subcategory'];
        if (isInstruction) {
            ignoreList.push('moduleMinMarkToPass');
        }

        if (isFormEmpty(values, ignoreList)) {
            return;
        }

        if (!this.refs.links.fileAndURLs.urls.length && !this.refs.links.fileAndURLs.files.length) {
            isArrayEmpty([], 'Please add File(s)/URL(s)');
            return;
        }

        let questions = [];
        let instructionsString = "";

        if (!isInstruction) {
            if (!this.refs.questions || isArrayEmpty(this.refs.questions.questions, 'Please add at-least one question set')) {
                return;
            }
            questions = this.refs.questions.questions;
        } else {
            const instTable = this.refs.instructionsTable as any;
            if (!instTable || instTable.state.instructions.length === 0) {
                isArrayEmpty([], 'Please add at-least one instruction');
                return;
            }
            // Send the raw array to the backend, it will be stored row by row
            const instArray = instTable.state.instructions;
            instructionsString = JSON.stringify(instArray);
        }

        return await updateModule(
            values.moduleName, values.moduleDesc, 
            isInstruction ? "0" : values.moduleMinMarkToPass, 
            values.TrainingDuration, this.refs.links.fileAndURLs.files,
            this.refs.links.fileAndURLs.urls, values.category, values.subcategory, 
            questions, this.props.history, this.props.match.params.id, 
            currentModuleType, instructionsString
        );
    }

    public renderContent = () => {
        if (!this.props.moduleInstance) {
            return <Loader type="async"/>;
        }
        const {Name, Links, Questions, Description, TrainingDuration, MinimumMarksToPass, Category, SubCategory, ModuleType, Instructions} = this.props.moduleInstance.props;
        
        // Use the prop from redux form if it has changed, otherwise fallback to the DB value
        const currentModuleType = this.props.moduleType !== 'Training Module' ? this.props.moduleType : (ModuleType || 'Training Module');
        const isInstruction = currentModuleType === 'Instruction Module';
        
        return <Form model="forms.moduleForm" onSubmit={this.handleSubmit} className="module-form">
            <InputField
                id="moduleType"
                hintText=""
                color={'white'}
                label="Module Type:"
                type="select"
                required
                model=".moduleType"
                noChips={true}
                menuItems={[
                    {label: "Training Module", value: "Training Module"},
                    {label: "Instruction Module", value: "Instruction Module"}
                ]}
                defaultValue={ModuleType || 'Training Module'}
            />
            <InputField
                id="moduleName"
                hintText=""
                label="Training Module Name:"
                type="text"
                required
                model=".moduleName"
                defaultValue={Name}
            />
            <InputField
                id="moduleDesc"
                hintText=""
                color="white"
                label="Training Module Description:"
                type="textarea"
                required
                model=".moduleDesc"
                defaultValue={Description}
            />
            {!isInstruction && (
                <InputField
                    id="moduleMinMarkToPass"
                    hintText=""
                    label="Minimum marks to pass:"
                    type="text"
                    required
                    model=".moduleMinMarkToPass"
                    defaultValue={MinimumMarksToPass || ''}
                />
            )}
            <InputField
                disabled={true}
                id="modulePeriod"
                hintText=""
                label="Training Period (In Days) :"
                type="number"
                minValue={1}
                required
                model=".TrainingDuration"
                defaultValue={TrainingDuration}
            />
            <InputField
                id="category"
                hintText=""
                color={'white'}
                label="Category:"
                required
                type="selectById"
                model=".category"
                noChips={true}
                onChange={this.onCategoryChange}
                menuItems={this.categoryOptions()}
                defaultValue={Category}
            />
            <InputField
                id="subcategory"
                hintText=""
                color={'white'}
                label="Sub Category:"
                required
                type="selectById"
                model=".subcategory"
                noChips={true}
                menuItems={this.state.subCategoryOpt ? this.state.subCategoryOpt : this.subcategoryOptions(SubCategory)}
                defaultValue ={SubCategory}
            />
            <FileInputComponent defaultValue={Links} AcceptFileType={FILESALLOWEDEXE} Extensions={FILESALLOWEDEXTENSION} ref="links"/>
            {!isInstruction && <QuestionsTable defaultValue={Questions} ref="questions"/>}
            {isInstruction && <InstructionsTable ref="instructionsTable" defaultValue={Instructions} />}
            <FormFooter submitLabel="Update Module"/>
        </Form>;
    }

    public render() {
        return <BasePage title="Update Training Module" icon="chalkboard-teacher">
            <Async
                identifier="ModuleUpdateForm"
                promise={this.promise}
                content={this.renderContent()}
                loader={<Loader type="async"/>}
                error={<ErrorPage/>}
            />
        </BasePage>;
    }
}

export function mapStateToProps(state, ownProps: IOwnProps) {
    return {
        moduleInstance: ModuleModel.get(ownProps.match.params.id),
        id: ownProps.match.params.id,
        moduleType: state.forms && state.forms.moduleForm ? state.forms.moduleForm.moduleType : 'Training Module'
    };
}

export const UpdateModule = withRouter(connect<{}, {}, IUpdateModuleProps>(mapStateToProps)(UpdateModuleImpl) as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Modules/UpdateModule.tsx